<div class="user-settings">
  <ion-list lines="full">
    <ion-item>
      <ion-label>
        <div class="item-label">{{ 'USER_INFO.EMAIL' | translate }}</div>
        <div class="item-value">{{ email || ('GENERAL.NOT_AVAILABLE' | translate) }}</div>
      </ion-label>
    </ion-item>

    <ion-item button (click)="goToChangePassword()">
      <ion-label>{{ 'PREMIUM_MENU.CHANGE_PASSWORD' | translate }}</ion-label>
      <ion-icon slot="end" name="chevron-forward" color="medium"></ion-icon>
    </ion-item>

    <ion-item *ngIf="isToggleEnabled('internationalization')" button (click)="openLanguageSwitcher()">
      <ion-label class="ion-text-wrap">
        <div>{{ 'ACCOUNT_SETTINGS.LANGUAGE' | translate }}</div>
        <ion-note color="medium" class="language-user-only-note">{{ 'GENERAL.LANGUAGE_APPLIES_TO_YOU_ONLY' | translate }}</ion-note>
      </ion-label>
      <div slot="end" class="language-display">
        <span class="language-flag">{{ currentLanguageInfo.flag }}</span>
        <span class="language-name">{{ currentLanguageInfo.name }}</span>
        <ion-icon name="chevron-forward" color="medium"></ion-icon>
      </div>
    </ion-item>

    <ion-item>
      <ion-label>
        <div class="item-label">{{ 'USER_SETTINGS.CURRENT_ACCOUNT' | translate }}</div>
        <div class="item-value">{{ currentAccountLabel() || ('GENERAL.NOT_AVAILABLE' | translate) }}</div>
      </ion-label>
      <ion-button slot="end" size="small" fill="solid" color="primary" (click)="goToSwitchAccounts()">
        {{ 'USER_SETTINGS.SWITCH_ACCOUNTS' | translate }}
      </ion-button>
    </ion-item>

    <ion-item *ngIf="isPremiumAccount()" button (click)="goToAlertSettings()">
      <ion-label>{{ 'ACCOUNT_ADMIN.ALERT_SETTINGS' | translate }}</ion-label>
      <ion-icon slot="end" name="chevron-forward" color="medium"></ion-icon>
    </ion-item>

    <ion-item *ngIf="isPremiumAccount()" button (click)="goToDeviceSettings()">
      <ion-label>{{ 'USER_SETTINGS.DEVICE_SETTINGS' | translate }}</ion-label>
      <ion-icon slot="end" name="chevron-forward" color="medium"></ion-icon>
    </ion-item>
  </ion-list>
</div>
